import { useMemo } from "react";
import { useStreamStatusStore } from "../store/streamStatusStore";
import { useCastDockStore } from "../store/castDockStore";
import { useOwnCastStore } from "../store/ownCastStore";
import { castKeyOf, dockOrder, watchedCastsOf, type DockCast } from "../lib/castDock";

/** The dock's cast cards in order: your own casts (ownCastStore, any GC), then the open GC's watched ones. */
export function useDockCasts(): DockCast[] {
  const infoByGc = useStreamStatusStore((s) => s.infoByGc);
  const gcId = useStreamStatusStore((s) => s.gcId);
  const hidden = useCastDockStore((s) => s.hidden);
  const seen = useCastDockStore((s) => s.seen);
  const ownCasts = useOwnCastStore((s) => s.casts);
  const own = useMemo<DockCast[]>(
    () =>
      Object.values(ownCasts).flatMap((c) =>
        c ? [{ key: castKeyOf(c.slot), slotId: c.slot.id, gcId: c.gcId, localId: c.localId, own: true, startedAt: c.startedAt }] : [],
      ),
    [ownCasts],
  );
  const ownKeys = useMemo(() => new Set(own.map((c) => c.key)), [own]);
  return useMemo(
    () => dockOrder(own, gcId == null ? [] : watchedCastsOf(infoByGc[gcId], gcId, ownKeys, hidden, seen)),
    [own, infoByGc, gcId, hidden, seen, ownKeys],
  );
}
